import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import { Colors } from "../../config";
import SText from "../SText";

// SCheckbox doesn't call onChange, for state management it depends on outside
const SCheckbox = props => {
  const {
    label,
    checked,
    onClick,
    onPress,
    containerStyle,
    checkboxStyle,
    checkboxTickStyle,
    labelStyle,
    ...restProps
  } = props;

  const styles = createStyles(props);

  return (
    <TouchableOpacity
      style={[styles.container, containerStyle]}
      onPress={onPress || onClick}
      {...restProps}
    >
      <View style={[styles.fakeCheckbox, checkboxStyle]}>
        {checked ? (
          <View style={[styles.fakeCheckboxTick, checkboxTickStyle]}>
            <SText size={14} color="white" weight="bold">
              {String.fromCharCode(10003)}
            </SText>
          </View>
        ) : null}
      </View>
      {label ? (
        <SText containerStyle={[styles.label, labelStyle]}>{label}</SText>
      ) : null}
    </TouchableOpacity>
  );
};

const createStyles = ({ checked, disabled }) =>
  StyleSheet.create({
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      opacity: disabled ? 0.6 : 1
    },
    fakeCheckbox: {
      position: "relative",
      height: 20,
      width: 20,
      borderRadius: 3,
      ...(checked
        ? {
            backgroundColor: disabled ? Colors.Grey[8] : Colors.Orange[4]
          }
        : {
            borderWidth: 1,
            borderColor: Colors.BlueGrey[4]
          })
    },
    fakeCheckboxTick: {
      position: "absolute",
      left: 3.5
    },
    label: {
      marginLeft: 14
    }
  });

SCheckbox.defaultProps = {
  checked: false,
  disabled: false,
  label: ""
};

SCheckbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string
};

export default SCheckbox;
